import { render, staticRenderFns } from "./PatientAllData.vue?vue&type=template&id=0bd1b831&"
import script from "./PatientAllData.vue?vue&type=script&lang=js&"
export * from "./PatientAllData.vue?vue&type=script&lang=js&"
import style0 from "./PatientAllData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports